<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{ title }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <ion-searchbar @keypress.enter="doSearch($event.target.value)" animated mode="ios" />
            <ion-item v-if="! (results && results.length > 0)">
                <ion-label>No results found</ion-label>
            </ion-item>
            <ion-item button v-for="location in results" :key="location.id" :detail="true" @click="select(location)">
                <ion-label class="ion-margin-start">
                    <h2>
                        {{ location.code }}
                        <ion-badge v-if="location.is_temporary" style="margin-left: 0.25em">temp</ion-badge>
                        <ion-badge v-if="location.is_returns"  style="margin-left: 0.25em">returns</ion-badge>
                    </h2>
                    <p>{{ location.description }}</p>
                </ion-label>
            </ion-item>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonSearchbar,
    IonPage,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonContent,
    IonButtons,
    IonButton,
    IonIcon,
    IonLabel,
    IonItem,
    IonBadge
} from '@ionic/vue';
import {modalController} from '@ionic/vue';
import {closeOutline} from 'ionicons/icons';
import EventBus from "@/EventBus";

export default {
    props: {modelValue: Number, title: {default: 'Location Search'}},
    emits: ['update:modelValue'],
    inject: ['$http'],
    name: 'LocationSearchModal',
    components: {
        IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons,
        IonButton, IonIcon, IonLabel, IonItem, IonSearchbar, IonBadge
    },
    data() {
        return {
            results: [],
            search: ''
        }
    },
    methods: {
        doSearch(search) {
            EventBus().emitter.emit('loading', true);
            this.$http
                // eslint-disable-next-line @typescript-eslint/camelcase
                .get('/api/locations', {params: { fts:search, include: 'zone', local_only: true, all: true }})
                .then(response => {
                    this.results = response.data.items;
                    EventBus().emitter.emit('loading', false);
                }).catch(() => {
                    EventBus().emitter.emit('loading', false);
                });
        },
        select(location) {
            console.log(location.id);
            modalController.dismiss(location);
        },
        close() {
            modalController.dismiss();
        }
    },
    setup() {
        return {
            closeOutline,
        }
    }
}
</script>
<style scoped>
ion-badge {
    vertical-align: bottom;
}
</style>
